export type NewsTag = "行业动态" | "动画介绍" | "新闻速递";

export type NewsItem = {
  id: string;
  title: string;
  summary: string;
  cover: string;
  publishedAt: string;
  tag: NewsTag;
  author: string;
  views: number;
  content: string[];
  relatedWorkIds: string[];
};

export const newsList: NewsItem[] = [
  {
    id: "n-001",
    title: "《星海回响》第二季正式定档，原创机甲番的野心与浪漫",
    summary:
      "制作组确认第二季将于十月开播，新视觉图与首支预告同步公开。这部以星际航线为舞台的原创动画，正在尝试用更克制的叙事讲一个更大的故事。",
    cover: "https://readdy.ai/api/search-image?query=Stylized%20anime%20key%20visual%20illustration%20of%20a%20young%20pilot%20standing%20in%20front%20of%20a%20glowing%20starship%20cockpit%2C%20warm%20orange%20rim%20light%20with%20deep%20navy%20shadows%2C%20clean%20minimal%20background%2C%20cinematic%20editorial%20poster%20art&width=800&height=500&seq=age-news-001&orientation=landscape",
    publishedAt: "2026-10-15",
    tag: "行业动态",
    author: "编辑部 · 林默",
    views: 18420,
    content: [
      "在昨晚结束的线上发表会中，《星海回响》制作组正式公布第二季的开播时间为十月第二周，并同步释出了全新的主视觉图与约九十秒的先导预告。对于一部原创机甲作品来说，这样的节奏显得格外稳健。",
      "从预告片来看，第二季的舞台将从近地轨道推向更遥远的深空航线。导演在采访中提到，团队并不打算用更大的爆炸场面来证明续作的价值，而是希望把镜头更多地留给角色在漫长航行中的沉默时刻。这种选择在当下的机甲题材里其实相当冒险。",
      "制作方面，本季将继续由原班班底负责，机械设定部分新增了两位年轻设计师。值得注意的是，预告中出现的三台新机型都保留了第一季那种带有工业感的接缝细节，而不是追求流线型的华丽造型。",
      "音乐依旧由第一季的配乐团队担纲。制片人透露，主题曲的创作方向会从上一季的「出发」转向「回望」，这与第二季整体的叙事基调相呼应。",
      "至于观众最关心的剧情走向，官方只给出了「航线会抵达终点，但代价需要有人承担」这样一句暧昧的说明。或许这正是这部作品最迷人的地方：它始终愿意把答案留到最后一刻。",
    ],
    relatedWorkIds: ["w-001", "w-011", "w-009"],
  },
  {
    id: "n-002",
    title: "2026 夏季新番前瞻：这十部作品值得加入追番列表",
    summary:
      "从治愈日常到硬核科幻，本季新番的类型分布格外均衡。我们按照题材整理了一份追番清单，帮你把有限的时间留给真正值得看的作品。",
    cover: "https://readdy.ai/api/search-image?query=Anime%20season%20lineup%20illustration%20with%20stacked%20colorful%20poster%20frames%20floating%20in%20a%20warm%20sunlit%20room%2C%20orange%20and%20cream%20tones%20with%20navy%20accents%2C%20flat%20editorial%20illustration%2C%20clean%20minimal%20background&width=800&height=500&seq=age-news-002&orientation=landscape",
    publishedAt: "2026-10-13",
    tag: "动画介绍",
    author: "编辑部 · 苏禾",
    views: 15230,
    content: [
      "每到换季，追番列表就会变成一场小型的选择困难。今年夏季的类型分布相当健康：既有稳扎稳打的续作，也有几部气质独特的新作，几乎没有出现某一类型扎堆的情况。",
      "如果你偏爱治愈系，可以从《雨巷食堂》开始。它把叙事重心放在一顿饭的时间里，节奏缓慢但不拖沓，适合在结束一天的疲惫之后打开。",
      "科幻爱好者则可以关注《零号列车》。这部作品用一列永不到站的列车作为舞台，讨论的是记忆与身份的老问题，但分镜语言相当新鲜。",
      "剧场版方面，《剑鸣之诗》与《夏日回声》分别代表了两种不同的方向：前者追求动作场面的密度，后者则更接近一部安静的青春小品。",
      "当然，清单只是参考。真正适合你的作品，往往是在某个毫无准备的夜晚，随手点开的那一集。",
    ],
    relatedWorkIds: ["w-003", "w-009", "w-004", "w-006"],
  },
  {
    id: "n-003",
    title: "动画工房宣布成立全新原创企划部门，聚焦短篇实验作品",
    summary:
      "新部门将由三位年轻监督共同负责，首年计划推出四部十二分钟左右的短篇动画。官方表示，这些作品不会以商业成绩作为唯一考核标准。",
    cover: "https://readdy.ai/api/search-image?query=Modern%20anime%20production%20studio%20workspace%20illustration%20with%20drawing%20tablets%2C%20storyboards%20and%20warm%20desk%20lamps%2C%20soft%20orange%20and%20beige%20palette%20with%20navy%20details%2C%20clean%20illustrated%20editorial%20style&width=800&height=500&seq=age-news-003&orientation=landscape",
    publishedAt: "2026-10-11",
    tag: "新闻速递",
    author: "编辑部 · 周原",
    views: 9870,
    content: [
      "动画工房在今日发布的公告中确认，将成立一个独立的原创企划部门，专门负责短篇动画的开发与制作。部门规模约为二十人，由三位平均年龄不到三十五岁的监督共同负责。",
      "根据公告内容，新部门首年计划推出四部时长约十二分钟的短篇作品，题材不设限制。制作委员会将不以票房或圆盘销量作为唯一考核指标，而是更看重作品在展示会与线上平台的讨论度。",
      "这一决定被业内视为对近年来「短篇化」趋势的回应。随着短视频平台对动画内容的接纳度提高，十二分钟左右的篇幅正在成为不少新人导演的起点。",
      "不过也有从业者提出担忧：短篇作品虽然门槛较低，但很难形成稳定的商业循环。对此官方回应称，实验部门的定位本就不同于主力的长篇产线，两者会保持独立核算。",
      "首部短篇预计于明年初公开，具体情报将在后续的展示活动中揭晓。",
    ],
    relatedWorkIds: ["w-007", "w-012"],
  },
  {
    id: "n-004",
    title: "角色解析：凌星野的成长弧线，为什么让人如此共情",
    summary:
      "他不是天生的英雄，甚至在很长一段时间里都在逃避责任。《星海回响》用二十四集的时间，把「成长」拆成了可以被看见的细小步伐。",
    cover: "https://readdy.ai/api/search-image?query=Emotional%20anime%20portrait%20illustration%20of%20a%20young%20male%20pilot%20looking%20at%20distant%20stars%20through%20a%20window%2C%20warm%20orange%20backlight%20and%20deep%20navy%20night%20tones%2C%20soft%20grain%2C%20cinematic%20editorial%20composition&width=800&height=500&seq=age-news-004&orientation=landscape",
    publishedAt: "2026-10-09",
    tag: "动画介绍",
    author: "专栏作者 · 顾南",
    views: 21150,
    content: [
      "凌星野第一次出现在屏幕上时，正躲在一艘旧货船的货舱里。他不是主角团里最强的那个，也不是最有信念的那个。恰恰是这种不确定，让他的成长有了可以被观众握住的分量。",
      "剧本对他的处理相当克制。第一季前半段，他每一次「站出来」都带着明显的犹豫，甚至会因为判断失误让队友陷入危险。作品没有急着为他安排高光时刻，而是先让他付出代价。",
      "真正让观众共情的，是第九集那场长达四分钟的独白。他没有说任何慷慨激昂的话，只是反复确认自己是否有资格继续留在船上。这种自我怀疑的真实感，远比任何热血台词更有力量。",
      "到了第二十四集，他做出的选择依然不是最完美的方案。但这一次，他清楚地知道自己在保护什么。所谓成长，大概就是从「被动地被推着走」，变成「主动地承担后果」。",
      "在角色设计层面，他的制服颜色从最初的灰蓝逐渐过渡到带着暖意的橙红，这种几乎不易察觉的变化，也是制作组留给观众的一份温柔提示。",
    ],
    relatedWorkIds: ["w-001"],
  },
  {
    id: "n-005",
    title: "《雨巷食堂》开播：日常番的温柔，从来不靠煽情",
    summary:
      "一家开在雨巷深处的小食堂，一位不太爱说话的女店主，和一整季来来去去的客人。这部作品把「治愈」拍成了一种生活节奏。",
    cover: "https://readdy.ai/api/search-image?query=Cozy%20anime%20illustration%20of%20a%20small%20lantern-lit%20restaurant%20in%20a%20rainy%20narrow%20alley%2C%20warm%20orange%20light%20reflecting%20on%20wet%20stone%20pavement%2C%20deep%20navy%20evening%20sky%2C%20cinematic%20editorial%20style&width=800&height=500&seq=age-news-005&orientation=landscape",
    publishedAt: "2026-10-07",
    tag: "动画介绍",
    author: "编辑部 · 苏禾",
    views: 13640,
    content: [
      "《雨巷食堂》的第一集没有开场旁白，也没有任何世界观说明。镜头只是安静地扫过雨后的巷子，然后停在一扇挂着布帘的木门前。",
      "女店主夏目桐的话很少，最常说的是「稍等一下」。她做菜的动作被拍得非常细：切葱花时手腕的角度、汤锅边缘浮起的气泡、端上桌时碗底与桌面接触的那一声轻响。这些细节构成了整部作品的情绪基底。",
      "每一集都有一位新的客人。故事不急着交代他们的过去，而是让他们在一顿饭的时间里慢慢松弛下来。很多时候，问题并没有被解决，但客人离开时的步伐确实轻了一些。",
      "这种叙事方式看起来很淡，实际上对剧本的要求极高。稍有用力过猛，就会滑向说教或刻意煽情。目前为止，作品控制得相当稳。",
      "如果你正在寻找一部不需要倍速、也不需要在意的番，这部大概就是答案。",
    ],
    relatedWorkIds: ["w-003", "w-010"],
  },
  {
    id: "n-006",
    title: "年度产业报告：剧场版票房再创新高，电视动画面临结构调整",
    summary:
      "最新发布的行业报告显示，剧场版动画的市场规模连续三年增长，而电视动画的集数总量出现小幅下滑。制作委员会制度正在被重新审视。",
    cover: "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20cinema%20hall%20with%20warm%20amber%20seats%20and%20a%20glowing%20screen%2C%20deep%20navy%20shadows%2C%20minimal%20geometric%20shapes%2C%20sophisticated%20magazine%20infographic%20aesthetic&width=800&height=500&seq=age-news-006&orientation=landscape",
    publishedAt: "2026-10-05",
    tag: "行业动态",
    author: "编辑部 · 周原",
    views: 8920,
    content: [
      "报告中最醒目的一组数据来自剧场版市场：过去三年，剧场版动画的总票房保持了稳定的两位数增长，其中原创剧场版所占的比例明显提升。",
      "与之相对，电视动画的年度总集数出现了小幅下滑。分析认为，这与制作资源的集中化有关——越来越多的预算流向了具备全球发行潜力的头部项目，中腰部作品的集数被压缩。",
      "报告还提到了制作委员会制度的变化。过去由多家公司分摊风险的模式，正在被更灵活的合作方式替代，部分作品开始尝试由平台方主导前期投资。",
      "对于观众来说，最直接的影响可能是作品类型的集中度上升。如何在商业确定性与创作多样性之间找到平衡，会是未来几年行业需要回答的问题。",
      "报告全文将在下月的行业论坛上公开，届时会有更多细分数据释出。",
    ],
    relatedWorkIds: ["w-011", "w-006", "w-004"],
  },
  {
    id: "n-007",
    title: "《赤月战线》第三集作画解析：动作分镜的节奏感从哪来",
    summary:
      "被观众称为「本季最佳战斗回」的第三集，其实没有使用太多炫技镜头。真正让人屏住呼吸的，是剪辑点与留白的设计。",
    cover: "https://readdy.ai/api/search-image?query=Dynamic%20anime%20action%20scene%20illustration%20of%20a%20silhouetted%20swordsman%20under%20a%20crimson%20moon%2C%20flying%20embers%2C%20strong%20orange%20and%20deep%20navy%20contrast%2C%20stylized%20brush%20texture%2C%20cinematic%20poster%20composition&width=800&height=500&seq=age-news-007&orientation=landscape",
    publishedAt: "2026-10-03",
    tag: "动画介绍",
    author: "专栏作者 · 顾南",
    views: 17480,
    content: [
      "第三集的战斗持续了大约七分钟，但真正的高潮其实只有四十秒。在这四十秒之前，导演用了近两分钟的时间来铺垫环境：风、脚步声、远处传来的钟鸣。",
      "这种处理方式在当下的动作番里并不常见。大多数作品会选择用连续的快速剪辑来制造紧张感，而《赤月战线》选择了相反的方向——把节奏放慢，让观众的注意力集中在角色的呼吸上。",
      "作画层面，本集的原画张数并不算特别高，但关键帧的构图极为讲究。黑川凛挥刀的那一卡，背景被处理成大面积的纯色块，只有刀光保留了细密的渐层，视觉重心的引导非常明确。",
      "值得一提的是音效的使用。刀锋接触的瞬间并没有放大人声或金属撞击，而是短暂地抽掉了环境音，留下一段几乎真空的沉默，再接上爆发。",
      "这类细节很难在第一次观看时被注意到，但它们共同构成了所谓的「作画回」。",
    ],
    relatedWorkIds: ["w-002"],
  },
  {
    id: "n-008",
    title: "声优阵容公布：《剑鸣之诗》剧场版追加三位主役",
    summary:
      "官方在今天下午公布了剧场版《剑鸣之诗》的完整声优名单，三位新加入的主役将分别饰演剑士团的年轻成员。首支正式预告将于下月公开。",
    cover: "https://readdy.ai/api/search-image?query=Elegant%20anime%20illustration%20of%20a%20group%20of%20young%20swordfighters%20standing%20on%20a%20stone%20terrace%20at%20sunset%2C%20warm%20golden%20and%20deep%20navy%20palette%2C%20flowing%20capes%2C%20clean%20minimal%20sky%20background%2C%20cinematic%20key%20visual&width=800&height=500&seq=age-news-008&orientation=landscape",
    publishedAt: "2026-10-01",
    tag: "新闻速递",
    author: "编辑部 · 林默",
    views: 11260,
    content: [
      "剧场版《剑鸣之诗》的官方账号在今天下午更新了声优名单。除此前已公布的主角阿尔文由原班声优继续饰演外，本次追加了三位新主役。",
      "三位新角色分别对应剑士团中不同代际的成员，官方同步放出了角色设定图。从造型来看，新角色的服装保留了作品一贯的亚麻质感与金属扣件细节。",
      "导演在随附的留言中表示，剧场版的时间线位于电视版之后，但并不会依赖前作的知识储备，新观众也可以独立理解故事。",
      "制作方面，剧场版的动作部分启用了新的作画班底，预计场面密度会明显高于电视版。首支正式预告定于下月中旬公开，届时也将公布上映影院名单。",
      "对于等待了两年的观众来说，这份名单大概已经足够让人期待了。",
    ],
    relatedWorkIds: ["w-004"],
  },
  {
    id: "n-009",
    title: "从《机械花园》看 OVA 市场的复苏：小体量作品的另一种可能",
    summary:
      "近两年，选择以 OVA 形式发行的作品数量明显回升。更自由的篇幅、更小的制作压力，让这类作品重新成为创作者试验风格的空间。",
    cover: "https://readdy.ai/api/search-image?query=Surreal%20anime%20illustration%20of%20a%20glass%20greenhouse%20filled%20with%20mechanical%20flowers%20and%20warm%20amber%20light%2C%20navy%20shadows%2C%20delicate%20linework%2C%20dreamy%20editorial%20art%20composition&width=800&height=500&seq=age-news-009&orientation=landscape",
    publishedAt: "2026-09-28",
    tag: "行业动态",
    author: "编辑部 · 周原",
    views: 7640,
    content: [
      "OVA 曾经是动画产业中最具实验性的部分。它不受电视档期与收视率的约束，也不需要在每一集结尾留下钩子。后来随着发行方式的变化，这类作品一度减少。",
      "《机械花园》的出现让人重新注意到这种形式。四集的篇幅，讲述了一个关于人造生命与记忆的安静故事，没有明显的续作铺垫，也没有为了延展而设置的多余支线。",
      "制作团队在采访中提到，OVA 最大的优势是「可以在一开始就知道结局」。这种确定性让剧本能够更精确地安排伏笔，而不必担心因为续订而调整方向。",
      "市场层面，流媒体平台对中等长度内容的需求正在增加。相比动辄二十多集的长篇，四到六集的作品更容易被海外观众接受，也更容易在短时间内形成话题。",
      "当然，OVA 并不会取代电视动画。它更像是产业里的一个小型试验田，安静，但一直有人在耕种。",
    ],
    relatedWorkIds: ["w-007", "w-010"],
  },
  {
    id: "n-010",
    title: "国创动画《山海异闻录》定档，东方美学的一次新表达",
    summary:
      "以古籍为灵感来源的《山海异闻录》确认将于年底上线。制作团队用三年时间打磨水墨质感的场景，试图在传统与当代叙事之间找到交点。",
    cover: "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20anime%20illustration%20of%20misty%20mountains%20with%20a%20lone%20traveler%20and%20a%20mythical%20winged%20creature%2C%20warm%20terracotta%20and%20deep%20indigo%20tones%2C%20elegant%20negative%20space%2C%20cinematic%20key%20visual&width=800&height=500&seq=age-news-010&orientation=landscape",
    publishedAt: "2026-09-25",
    tag: "新闻速递",
    author: "编辑部 · 苏禾",
    views: 14390,
    content: [
      "《山海异闻录》的定档消息公布得相当低调，只有一支两分钟的先导预告和一张定档海报。但预告片里那种介于水墨与赛璐璐之间的质感，很快在社交平台上引发了讨论。",
      "制作团队在接受采访时表示，作品的世界观参考了多部古籍，但并没有试图做一部「考据向」的作品。他们更关心的是，如何让这些古老的意象在今天依然能引起情绪共鸣。",
      "技术层面，团队开发了一套用于处理笔触边缘的工具，让三维场景在渲染后保留手绘的不规则感。这种做法在近年的国创作品中并不少见，但本作的克制程度相当高。",
      "主角云翼的设定也颇具意味：他不是传统意义上的天选之人，而是一个负责记录异闻的普通书生。故事的推进方式更接近公路片，一集一个地点。",
      "作品将于年底上线，首季共十二集。",
    ],
    relatedWorkIds: ["w-008"],
  },
  {
    id: "n-011",
    title: "夏日番配乐盘点：那些让人单曲循环的 OST",
    summary:
      "一部好的动画，往往有一半的情绪是由音乐完成的。这一季我们挑出了五张值得反复播放的原声专辑，聊聊它们各自的声音设计。",
    cover: "https://readdy.ai/api/search-image?query=Warm%20editorial%20illustration%20of%20vintage%20headphones%2C%20sheet%20music%20and%20a%20glowing%20sunset%20window%2C%20orange%20and%20cream%20palette%20with%20navy%20accents%2C%20clean%20minimal%20composition%2C%20sophisticated%20magazine%20style&width=800&height=500&seq=age-news-011&orientation=landscape",
    publishedAt: "2026-09-22",
    tag: "动画介绍",
    author: "专栏作者 · 顾南",
    views: 10380,
    content: [
      "音乐在动画里的作用，很多时候是替观众说出那些角色没有说出口的话。这一季的几部作品，在配乐上都做出了相当明确的选择。",
      "《雨巷食堂》几乎全部使用原声乐器，钢琴与木吉他的比例控制得很低，更多时候让环境音承担情绪推进。这种做法让整部作品听起来像一段被记录下来的生活。",
      "《星海回响》则走向另一个极端：大量使用合成器与低频铺底，营造出宇宙空间的空旷感。有意思的是，它在最激烈的战斗段落反而撤掉了鼓点。",
      "《零号列车》的配乐最具实验性，制作组邀请了电子音乐人参与，把列车行进的节奏直接采样进曲目里。闭上眼睛听，几乎能看见车厢的晃动。",
      "如果你习惯在通勤路上听歌，这几张原声大概都能陪你走过一段不算短的路。",
    ],
    relatedWorkIds: ["w-003", "w-001", "w-009"],
  },
  {
    id: "n-012",
    title: "行业观察：短篇动画，正在成为新人导演的跳板",
    summary:
      "从十二分钟的实验短片到正式的长篇企划，越来越多的年轻创作者选择用短篇作为敲门砖。平台、工作室与观众之间的关系也在悄悄改变。",
    cover: "https://readdy.ai/api/search-image?query=Minimal%20editorial%20illustration%20of%20a%20film%20clapperboard%20and%20storyboard%20sketches%20on%20a%20warm%20wooden%20desk%2C%20orange%20and%20beige%20palette%2C%20navy%20accents%2C%20clean%20flat%20design%2C%20sophisticated%20magazine%20layout&width=800&height=500&seq=age-news-012&orientation=landscape",
    publishedAt: "2026-09-19",
    tag: "行业动态",
    author: "编辑部 · 林默",
    views: 6480,
    content: [
      "在过去，一位新人导演想要获得长篇企划的机会，通常需要在原画或演出的岗位上积累多年。现在，这条路正在变得更短，也更复杂。",
      "短篇动画的兴起提供了一种新的曝光方式。十二分钟的篇幅足以展示导演对节奏、构图与情绪的整体把控，同时又把制作成本控制在了可承受的范围内。",
      "几家工作室已经开始把短篇作为正式的选拔机制。作品在线上发布后，数据表现与讨论度会成为是否推进长篇企划的重要参考。",
      "不过，短篇与长篇之间仍然存在明显的鸿沟。前者可以依靠一个强烈的概念支撑，后者则需要持续的角色动力与结构设计。",
      "真正值得关注的，或许不是短篇本身，而是它让更多不同的声音有机会被听见。",
    ],
    relatedWorkIds: ["w-012", "w-007"],
  },
];

export const getNewsById = (id?: string) => newsList.find((item) => item.id === id);